import gql from 'graphql-tag';

export const questionnaireAnswers = gql`
  query questionnaireAnswers($id: Long!) {
    questionnaireAnswers(id: $id) {
      id
      type
      procedureId
      questions
      answers
      submittedAt
      defaultValues
    }
  }
`;

export const myQuestionnaireAnswers = gql`
  query myQuestionnaireAnswers($patientDateOfBirth: Date!) {
    myQuestionnaireAnswers(patientDateOfBirth: $patientDateOfBirth) {
      id
      type
      questions
      answers
      submittedAt
      defaultValues
    }
  }
`;

export const submitQuestionnaireAnswers = gql`
  mutation submitQuestionnaireAnswers($patientDateOfBirth: Date!, $answers: String!) {
    submitQuestionnaireAnswers(patientDateOfBirth: $patientDateOfBirth, answers: $answers) {
      id
      questions
      answers
      submittedAt
    }
  }
`;

export const editQuestionnaireAnswers = gql`
  mutation editQuestionnaireAnswers($id: Long!, $answers: String!) {
    editQuestionnaireAnswers(id: $id, answers: $answers) {
      id
      questions
      answers
      submittedAt
    }
  }
`;

export const requestAuthenticationCode = gql`
  mutation requestAuthenticationCode {
    requestAuthenticationCode {
      status
      phoneNumbers
      emailAddresses
      session {
        token
        validUntil
      }
    }
  }
`;

export const verifyPatientDateOfBirth = gql`
  mutation verifyPatientDateOfBirth($patientDateOfBirth: Date!) {
    verifyPatientDateOfBirth(patientDateOfBirth: $patientDateOfBirth)
  }
`;

export const verifyAuthenticationCode = gql`
  mutation verifyAuthenticationCode($token: String!) {
    verifyAuthenticationCode(token: $token) {
      token
      validUntil
    }
  }
`;

export const extendAuthenticationCode = gql`
  mutation extendAuthenticationCode($token: String!) {
    extendAuthenticationCode(token: $token) {
      token
      validUntil
    }
  }
`;

export const getSurgeryInstructions = gql`
  query surgeryInstructions {
    surgeryInstructions
    myInstructionAcceptance
  }
`;

export const getPastSurgeryInstructions = gql`
  query pastSurgeryInstructions($id: Long!, $version: Long) {
    surgeryInstructions: pastSurgeryInstructions(id: $id, version: $version)
  }
`;

export const acceptSurgeryInstructions = gql`
  mutation acceptSurgeryInstructions($content: String!) {
    acceptSurgeryInstructions(content: $content)
  }
`;

export const procedure = gql`
  query procedure($id: Long!) {
    procedure(id: $id) {
      id
      patientName
    }
  }
`;

const questionnaire = {
  myQuestionnaireAnswers,
  submitQuestionnaireAnswers,
  getSurgeryInstructions,
  acceptSurgeryInstructions,
};

export default questionnaire;
